export default class MarcheSecuriteChantiersDto {
  id;
  marche;
  effectifPersonnelGroupement;
  effectifPersonnelGroupement12m;
  effectifInterimaires;
  effectifInterimaires12m;
  effectifSousTraitants;
  effectifSousTraitants12m;
  effectifGlobalChantier;
  effectifGlobalChantier12m;
  effectifEncadrementChantier;
  effectifEncadrementChantier12m;
  effectifGlobalChantierEncadrement;
  effectifGlobalChantierEncadrement12m;
  nbHeuresTravPersonnelGroupement;
  nbHeuresTravPersonnelGroupement12m;
  nbHeuresTravInterimaires;
  nbHeuresTravInterimaires12m;
  nbHeuresTravSousTraitants;
  nbHeuresTravSousTraitants12m;
  nbHeuresTravGlobalChantier;
  nbHeuresTravGlobalChantier12m;
  nbHeuresTravEncadrementChantier;
  nbHeuresTravEncadrementChantier12m;
  nbHeuresTravGlobalChantierEncadrement;
  nbHeuresTravGlobalChantierEncadrement12m;
  nbAccidentSansArretPersonnelGroupement;
  nbAccidentSansArretPersonnelGroupement12m;
  nbAccidentSansArretInterimaires;
  nbAccidentSansArretInterimaires12m;
  nbAccidentSansArretSousTraitants;
  nbAccidentSansArretSousTraitants12m;
  nbAccidentSansArretGlobalChantier;
  nbAccidentSansArretGlobalChantier12m;
  nbAccidentSansArretEncadrementChantier;
  nbAccidentSansArretEncadrementChantier12m;
  nbAccidentSansArretGlobalChantierEncadrement;
  nbAccidentSansArretGlobalChantierEncadrement12m;
  nbAccidentAvecArretPersonnelGroupement;
  nbAccidentAvecArretPersonnelGroupement12m;
  nbAccidentAvecArretInterimaires;
  nbAccidentAvecArretInterimaires12m;
  nbAccidentAvecArretSousTraitants;
  nbAccidentAvecArretSousTraitants12m;
  nbAccidentAvecArretGlobalChantier;
  nbAccidentAvecArretGlobalChantier12m;
  nbAccidentAvecArretEncadrementChantier;
  nbAccidentAvecArretEncadrementChantier12m;
  nbAccidentAvecArretGlobalChantierEncadrement;
  nbAccidentAvecArretGlobalChantierEncadrement12m;
  nbJourArretPersonnelGroupement;
  nbJourArretPersonnelGroupement12m;
  nbJourArretInterimaires;
  nbJourArretInterimaires12m;
  nbJourArretSousTraitants;
  nbJourArretSousTraitants12m;
  nbJourArretGlobalChantier;
  nbJourArretGlobalChantier12m;
  nbJourArretEncadrementChantier;
  nbJourArretEncadrementChantier12m;
  nbJourArretGlobalChantierEncadrement;
  nbJourArretGlobalChantierEncadrement12m;
  tauxFrequencePersonnelGroupement;
  tauxFrequencePersonnelGroupement12m;
  tauxFrequenceInterimaires;
  tauxFrequenceInterimaires12m;
  tauxFrequenceSousTraitants;
  tauxFrequenceSousTraitants12m;
  tauxFrequenceGlobalChantier;
  tauxFrequenceGlobalChantier12m;
  tauxFrequenceEncadrementChantier;
  tauxFrequenceEncadrementChantier12m;
  tauxFrequenceGlobalChantierEncadrement;
  tauxFrequenceGlobalChantierEncadrement12m;
  indiceFrequencePersonnelGroupement;
  indiceFrequencePersonnelGroupement12m;
  indiceFrequenceInterimaires;
  indiceFrequenceInterimaires12m;
  indiceFrequenceSousTraitants;
  indiceFrequenceSousTraitants12m;
  indiceFrequenceGlobalChantier;
  indiceFrequenceGlobalChantier12m;
  indiceFrequenceEncadrementChantier;
  indiceFrequenceEncadrementChantier12m;
  indiceFrequenceGlobalChantierEncadrement;
  indiceFrequenceGlobalChantierEncadrement12m;
  tauxGravitePersonnelGroupement;
  tauxGravitePersonnelGroupement12m;
  tauxGraviteInterimaires;
  tauxGraviteInterimaires12m;
  tauxGraviteSousTraitants;
  tauxGraviteSousTraitants12m;
  tauxGraviteGlobalChantier;
  tauxGraviteGlobalChantier12m;
  tauxGraviteEncadrementChantier;
  tauxGraviteEncadrementChantier12m;
  tauxGraviteGlobalChantierEncadrement;
  tauxGraviteGlobalChantierEncadrement12m;
  commentaire;
  statut;
  jourSoumissionPassed;
  date;
  user;
}
